import { SelectableItemModel } from '../../../../../api-service/clients';
import { blobToBase64 } from '../../../../../hooks/audio/blob-to-base64';
import { ICreateChatResult, ISelectableItem } from './create-chat-dialog';

export function toSelectableItems(items: SelectableItemModel[] | undefined): ISelectableItem[] {
  return (items ?? []).map(item => ({ id: item.id, title: item.title ?? '' }));
}

// One file at a time, so many large files are not held encoded in memory together before the call.
async function toAttachmentUploads(files: File[]) {
  const uploads = [];
  for (const file of files) {
    uploads.push({ content: await blobToBase64(file), fileName: file.name, mimeType: file.type });
  }
  return uploads;
}

export async function toAddChatRequest(citizenId: string, result: ICreateChatResult) {
  return {
    title: result.title,
    citizenExternalId: citizenId,
    contactExternalIds: result.contactIds,
    caseId: result.caseId,
    initialMessageContent: result.message,
    isConfidential: result.isConfidential,
    attachments: await toAttachmentUploads(result.attachments),
  };
}
